import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/ducks';
import { useEventsBanner } from 'hooks/useEventsBanner';

import bannerDashMel from 'img/DashMel.png';

import { ImgBanner } from './styles';
import { IBannerProps } from './interface';

export const Banner: React.FC<IBannerProps> = ({className}: IBannerProps) => {

    const dispatch = useDispatch();
    const banner = useSelector((state: RootState) => state.eventsBanner);

    const isBannerActive = !!banner?.url_banner_dashboard;

    useEventsBanner(dispatch, isBannerActive);

    const viewBanner = () => {
        if (banner && isBannerActive)
            return banner.url_banner_dashboard;

        return bannerDashMel;
    };

    return (
        <ImgBanner
            className={className}
            src={viewBanner()}
            alt=""
        />
    );
}